import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

export const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 px-6 lg:px-8 relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-30">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/019b4c41-3267-4b2f-8cd8-cbbc3514ec1e/images/efda90164bc373a90a7434ac7765cd6cf5b2747649f28d9d93bf0bc16748f507.png')`,
            maskImage: 'linear-gradient(to left, black, transparent)',
            WebkitMaskImage: 'linear-gradient(to left, black, transparent)',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <span className="text-primary text-sm font-medium tracking-wider uppercase">
              About
            </span>
            <h2
              data-testid="about-title"
              className="font-['Sora'] text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mt-2 tracking-tight"
            >
              About the Studio
            </h2>
            
            <div className="w-16 h-1 bg-primary mt-6 mb-8" />
            
            <p
              data-testid="about-text"
              className="text-lg text-muted-foreground leading-relaxed mb-6"
            >
              Damian Depasquale Creative Studio is focused on building modern visuals for
              brands, businesses, and digital platforms. From logo design and
              visual identity to content creation and custom creative work, each
              project is designed with clarity, impact, and intention.
            </p>
            
            <p className="text-muted-foreground leading-relaxed">
              Every project begins with understanding your goals and audience.
              The result is design that not only looks exceptional but works
              strategically to elevate your brand and connect with your market.
            </p>
          </motion.div>

          {/* Visual Element */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="hidden lg:block"
          >
            <div className="relative">
              <div className="aspect-square rounded-2xl overflow-hidden border border-border/50">
                <img
                  src="https://static.prod-images.emergentagent.com/jobs/019b4c41-3267-4b2f-8cd8-cbbc3514ec1e/images/efda90164bc373a90a7434ac7765cd6cf5b2747649f28d9d93bf0bc16748f507.png"
                  alt="DDesign Creative Studio"
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Floating accent */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-primary/10 rounded-xl border border-primary/30" />
              <div className="absolute -top-6 -right-6 w-16 h-16 bg-primary/20 rounded-lg border border-primary/30" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
